import React from 'react';
import { Box, CircularProgress, Typography, SxProps, Theme } from '@mui/material';

interface LoadingScreenProps {
    message?: string;
    size?: 'small' | 'large' | 'medium';
    fullScreen?: boolean;
    sx?: SxProps<Theme>;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
    message = 'Loading...',
    size = 'medium',
    fullScreen = true,
    sx = {}
}) => {
    const getSize = () => {
        switch (size) {
            case 'small': return 24;
            case 'large': return 48;
            default: return 40;
        }
    };

    const containerSx: SxProps<Theme> = fullScreen ? {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        ...sx
    } : {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 3,
        ...sx
    };

    return (
        <Box sx={containerSx}>
            <CircularProgress size={getSize()} sx={{ mb: 2 }} />
            {message && (
                <Typography variant="body1" color="text.secondary">
                    {message}
                </Typography>
            )}
        </Box>
    );
};

export default LoadingScreen;
